var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0 xl:p-8"},[_c('barcode-login-handler',[(!_vm.hideButtonToManualLogin)?_c('div',{staticClass:"mt-6"},[_c('button-element',{attrs:{"size":"small","type":"light"},on:{"click":function($event){return _vm.$router.push({name: 'auth.login'})}}},[_vm._v(" Entrée manuelle ")])],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }